import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import {
  Form, Button, Row, Col,
} from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import momentLocalizer from 'react-widgets-moment';
import Input from '../components/Input';
import { LoadingIcon } from '../components/Loading';
import RadioGroup from '../components/RadioGroup';
import { RenderDateTimePickerNew } from '../components/DateTimePicker';
import { renderSelectInput } from '../components/SelectInput';
import { returnBreedListForType, returnColorList } from '../components/BreedList';

import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

const validate = (values) => {
  const errors = {};
  if (isEmpty(values.clientName)) {
    errors.clientName = 'Enter name';
  }
  if (isEmpty(values.petName)) {
    errors.petName = 'Enter name';
  }
  if (!values.petBreed) {
    errors.petBreed = 'Enter breed';
  }
  if (isEmpty(values.petGender)) {
    errors.petGender = 'Enter gender';
  }
  if (!values.petType) {
    errors.petType = 'Enter type';
  }
  if (!values.petColor) {
    errors.petColor = 'Enter color';
  }
  if (/^\d{10}$/.test(values.phoneM1) === false && !isEmpty(values.phoneM1)) {
    errors.clientPhoneM1 = 'Please check mobile number 1 (M1)';
  }
  if (/^\d{10}$/.test(values.phoneM2) === false && !isEmpty(values.phoneM2)) {
    errors.clientPhoneM2 = 'Please check mobile number 2 (M2)';
  }

  return errors;
};

let CreateClientAndPetForm = (props) => {
  const {
    handleSubmit,
    submitting,
    isLoading,
    selectedType,
  } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="pt-3 pb-3">
        <Col sm="2" />
        <Col sm={{ size: 10 }}>
          <h5 className="d-flex justify-content-center">
            Client Information
          </h5>
        </Col>
      </Row>
      <Field
        component={Input}
        name="clientName"
        type="name"
        label="Name"
        disabled={submitting || isLoading}
        required
      />
      <Field
        component={Input}
        name="clientEmail1"
        type="text"
        label="Email (1)"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientEmail2"
        type="text"
        label="Email (2)"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientAddress"
        type="address"
        label="Address"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientCity"
        type="city"
        label="City"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientState"
        type="state"
        label="State"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientPincode"
        type="pincode"
        label="Pincode"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientPhoneR"
        type="tel"
        label="Phone (R)"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientPhoneM1"
        type="tel"
        label="Phone (M1)"
        disabled={submitting || isLoading}
      />
      <Field
        component={Input}
        name="clientPhoneM2"
        type="tel"
        label="Phone (M2)"
        disabled={submitting || isLoading}
      />
      <Row className="pt-3 pb-3">
        <Col sm="2" />
        <Col sm={{ size: 10 }}>
          <h5 className="d-flex justify-content-center">
            Pet Information
          </h5>
        </Col>
      </Row>
      <Field
        component={renderSelectInput}
        name="petType"
        label="Type"
        disabled={submitting || isLoading}
        list={[
          {
            label: 'Canine',
            value: 1,
          },
          {
            label: 'Feline',
            value: 2,
          },
          {
            label: 'Other',
            value: 3,
          },
        ]}
      />
      <Field
        component={Input}
        name="petName"
        type="name"
        label="Name"
        disabled={submitting || isLoading}
        required
      />
      <Field
        name="petGender"
        component={RadioGroup}
        label="Gender"
      />
      <Field
        component={selectedType && selectedType.value === 3 ? Input : renderSelectInput}
        name="petBreed"
        type={selectedType && selectedType.value === 3 ? 'text' : 'select'}
        label="Breed"
        list={selectedType && returnBreedListForType(selectedType.value)}
        disabled={submitting || isLoading}
        required
      />
      <Field
        component={RenderDateTimePickerNew}
        name="petDob"
        showTime={false}
        label="Date of birth"
        required
        isNew
      />
      <Field
        component={renderSelectInput}
        name="petColor"
        type="select"
        label="Color"
        disabled={submitting || isLoading}
        list={returnColorList()}
        required
      />
      <Button
        type="submit"
        color="primary"
        disabled={submitting || isLoading}
        block
        style={{ marginTop: '20px' }}
      >
        {isLoading && (
          <LoadingIcon />
        )}
        Submit
      </Button>
    </Form>
  );
};

const selector = formValueSelector('CREATE_CLIENT_AND_PET');


CreateClientAndPetForm = connect((state) => {
  const selectedType = selector(state, 'petType');
  return {
    selectedType,
  };
})(CreateClientAndPetForm);


CreateClientAndPetForm = reduxForm({
  form: 'CREATE_CLIENT_AND_PET',
  validate,
})(CreateClientAndPetForm);

export default injectIntl(CreateClientAndPetForm);
